import React, { useEffect, useState } from 'react';
import { GetPaymentCreate } from "../../dao/root/GetPaymentCreate";

const Pagament = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAndRedirect = async () => {
            setLoading(true);
            const dades = await GetPaymentCreate("");
            if (dades?.challengeUrl) {
                window.location.href = dades.challengeUrl;
            } else {
                // Manejo de error si no viene la URL
                console.error("No se recibió challengeUrl");
            }
            setLoading(false);
        };

        fetchAndRedirect();
    }, []);

    return (
        <div className="container mt-5">
            <h2>Redirigiendo al pago con tarjeta...</h2>
            {loading && <p>Cargando pasarela de pago...</p>}
        </div>
    );
};

export default Pagament;
